import { render, staticRenderFns } from "./PackageRequests.vue?vue&type=template&id=0409e0d7&"
import script from "./PackageRequests.vue?vue&type=script&lang=js&"
export * from "./PackageRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports